// assets/cart.core.js
const { createApp, ref } = Vue;

// PhpStorm inference:
const CartMethodsApi = window.CartMethodsApi || {};
const CartMethodsImprint = window.CartMethodsImprint || {};
const CartMethodsPricing = window.CartMethodsPricing || {};
const CartMethodsGrouping = window.CartMethodsGrouping || {};
const CartMethodsFees = window.CartMethodsFees || {};
const CartMethodsUI = window.CartMethodsUI || {};
const CartMethodsStorage = window.CartMethodsStorage || {};
const CartMethodsState = window.CartMethodsState || {};

window.__cartVueProxy = createApp({
    delimiters: ['${', '}'],

    data() {
        return {
            cartItems: null,
            storageCart: null,
            productIds: [],
            assocToProduct: {},
            standartProductProp: ['Color','Size','color','imprint'],
            imprintDetailKeys: [
                'Imprint location',
                'Line 1 text',
                'Line 2 text',
                'Line 3 text',
                'Line 4 text',
                'Line 5 text',
                'Line 1 color',
                'Line 2 color',
                'Line 3 color',
                'Line 4 color',
                'Line 5 color',
                'Add an Image Filename',
                'Special Instruction',
                'Imprint Details',
                'Imprint Method'
            ],
            calendarStandartProps: ['Is Calendar','Calendar SKU'],
            properties: {},
            updateFromLocalStorage: true,
            loader: true,
            subtotalPrice: 0,
            qtyIncriment: {}, // {productID<Int> : incriment<Int>}
            productTitle:{},
            assocPropsEmpty: {
                'Shipping Fee': 0.00,
                'Setup Fee': 0.00,
                'Proof Fee': 0.00,
                'Image Fee': 0.00,
                ...(window.Shopify.country === "US" && {'Custom Color Fee': 0.00}),
                ...(window.Shopify.country === "CA" && {'Custom Colour Fee': 0.00}),
                'Running Fee': 0.00,
                'Additional Location Fee':0.00

            },
            feeDescription: {
                'Shipping Fee': 'The cost to cover the shipping and handling fees from our freight provider.',
                'Setup Fee': 'The industry standard cost associated with setting up the screen, die, laser, or other necessary items to imprint your specific logo.',
                'Proof Fee': 'The cost to digitize your artwork (company name/logo/message) and digitally render it on a product for review prior to production.',
                'Image Fee': 'The fees associated with formatting, retouching, and/or redrawing custom logos.',
                ...(window.Shopify.country === "US" && {'Custom Color Fee': 'PMS (Pantone) color match fee, applied when creating non-standard imprint colors (matching to existing logo, etc.).'}),
                ...(window.Shopify.country === "CA" && {'Custom Colour Fee': 'PMS (Pantone) colour match fee, applied when creating non-standard imprint colours (matching to existing logo, etc.).'}),
                'Running Fee': `Pricing varies by product ${window.Shopify.country === "CA" ? 'colour' : 'color'}, size and material. Standard pricing includes 1 ${window.Shopify.country === "CA" ? 'colour' : 'color'} imprint on standard products, 2XL sizes, different fabrics, etc. may be customized for additional fees.`,
                'Additional Location Fee': 'Fee applied when an order includes more than one imprint location on the same product.'
            },
            subtotalDiscounts:0,
            discountFromCart: [],
            productByGroupID: {},
            disableCheckout: false,
            priceChange:{},
            prepareData: {},
            prepareItems: {},
            minProductQty: {},
            disableUpdateCart: false,
            qtyPending: false,
            qtySyncLocked: false,
            checkoutInProgress: false,
            assocFeesSummaryOpen: false,
            totalQtyByGroupID: {},
            linePriceProperty: 'original_line_price',
            maxQty: 10000,
            minQty: 0
        };
    },

    methods: {
        // 🧩 mix all method packs (order doesn't matter except if you overwrite names)
        ...CartMethodsApi,
        ...CartMethodsImprint,
        ...CartMethodsPricing,
        ...CartMethodsGrouping,
        ...CartMethodsFees,
        ...CartMethodsUI,
        ...CartMethodsStorage,
        ...CartMethodsState,
    },

    async created() {
        if (window.__cartRecoveryPromise) {
            try {
                const result = await window.__cartRecoveryPromise;
                if (result && result.broken) {
                    window.location.reload();
                    return; // never finish mounting this broken cycle
                }
            } catch (e) {
                // never block cart rendering on a recovery-check failure
                console.error('[CS-316] recovery check failed during created():', e);
            }
        }
        this.initCartItemsData();
        this.calculateFee();
        this.updateDiscountFromCart();
    },

    mounted() {
        this.loader = false;
    }
}).mount('#cart_form');